/**
 * @file index.js
 * @author Alvaro Martinez
 * @description Initialize Proteinuria Details List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './BloodPressureListView';

export const mapStateToPropsBloodPressureList = mapStateToProps;
export const mapDispatchToPropsBloodPressureList = mapDispatchToProps;

export default connect(
  mapStateToPropsBloodPressureList,
  mapDispatchToPropsBloodPressureList
)(View);
